import { createApi, fetchBaseQuery, } from '@reduxjs/toolkit/query/react';
import { secureBaseQuery } from './secureBaseQuery';
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";
export const transactionApi = createApi({
    reducerPath: 'transactionApi',
    baseQuery: fetchBaseQuery({ 
        baseUrl: api,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('accessToken');
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
        //  baseQuery: dynamicBaseQuery,
    tagTypes: ['Transaction'],
    endpoints: (builder) => ({
        getTransactionHistory: builder.query({
            query: ({ fromDate, toDate, page = 1, limit = 20 }) => ({
                url: '/reseller/get-transaction-history',
                method: 'GET',
                params: { fromDate, toDate, page, limit }
            }),
            providesTags: ['Transaction'],
        }),
        searchTransactionHistory: builder.query({
  query: ({ fromDate, toDate, page = 1, limit = 20, search = "" }) => ({
    url: "/reseller/search-transaction-history",
    method: "GET",
    params: { fromDate, toDate, page, limit, search },
  }),
  providesTags: ["Transaction"],
}),
    }),
});

export const {
    useGetTransactionHistoryQuery,
    useSearchTransactionHistoryQuery
} = transactionApi;
